import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle, } from 'react';
import { useTranslation } from 'react-i18next';
import { AgGridReact } from 'ag-grid-react';
import { toast } from 'react-toastify';
import { useOrderColumns } from './columns';
import { useOrderData } from './data';
import { LicenseManager } from 'ag-grid-enterprise';
import { getLocaleText } from 'utils/localization/agGridLocale';
import { frameworkComponents } from './frameworkComponents';
import LoadingSkeleton from './LoadingSkeleton';
LicenseManager.setLicenseKey(`${AG_GRID_LICENSE}`);
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
const gridOpts = {
    defaultColDef: {
        enableRowGroup: true,
        enablePivot: false,
        sortable: true,
        resizable: true,
        floatingFilter: true,
        filter: 'agTextColumnFilter',
    },
    rowDragManaged: true,
    copyHeadersToClipboard: true,
    suppressColumnVirtualisation: true,
    suppressScrollOnNewData: true,
};
const ExploreOrderUnifiedView = forwardRef(function ExploreOrderUnifiedView({ onTotalCountChange, onSelectionChanged, sidebarParams }, ref) {
    // Hooks
    const { t } = useTranslation();
    const columns = useOrderColumns();
    const { data: items = [], isLoading, isError, error } = useOrderData();
    const apiRef = useRef(null);
    useImperativeHandle(ref, () => ({
        get api() {
            return apiRef.current;
        },
        getSelectedRows: () => {
            if (!apiRef.current) {
                return [];
            }
            return apiRef.current.getSelectedRows().map((order) => (Object.assign(Object.assign({}, order), { _id: order._id, id: order._id })));
        },
    }));
    useEffect(() => {
        if (isError && error) {
            toast.error(`Error loading orders: ${error.message}`);
        }
    }, [isError, error]);
    useEffect(() => {
        if (onTotalCountChange) {
            onTotalCountChange(items.length);
        }
    }, [items, onTotalCountChange]);
    // Grid Items
    const getRowId = (params) => params.data.order_oid;
    const statusBar = {
        statusPanels: [{ statusPanel: 'agAggregationComponent' }],
    };
    const getRowHeight = (params) => 50;
    const onGridReady = (params) => {
        const { api, columnApi } = params;
        apiRef.current = api;
        api.autoSizeColumns();
    };
    if (isLoading) {
        return React.createElement(LoadingSkeleton, null);
    }
    return (React.createElement("div", { "data-testid": "div-da5f52c9", className: "h-full w-full" },
        React.createElement(AgGridReact, { rowData: items, maintainColumnOrder: true, rememberGroupStateWhenNewData: true, animateRows: true, getRowHeight: getRowHeight, getRowId: getRowId, suppressClickEdit: true, suppressRowClickSelection: true, enableCellTextSelection: true, enableRangeSelection: true, rowSelection: "multiple", components: frameworkComponents, multiSortKey: "ctrl", onGridReady: onGridReady, onSortChanged: () => console.log('implement'), statusBar: statusBar, columnDefs: columns, defaultColDef: gridOpts.defaultColDef, onSelectionChanged: onSelectionChanged, localeText: getLocaleText(), overlayLoadingTemplate: `<div><span class="text-base text-green font-bold">${t('LOADING')}</span></div>`, sideBar: sidebarParams, allowDragFromColumnsToolPanel: true })));
});
export default ExploreOrderUnifiedView;
